export const accessibilityConstants = {
    STORE_ACCESSIBILITY_DATA: 'STORE_ACCESSIBILITY_DATA', 
  
    EASY_ACCESSIBILITY: 100,
    NORMAL_ACCESSIBILITY: 200,
    BAD_ACCESSIBILITY: 300
  };
  